"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _BaseOverview = _interopRequireDefault(require("./BaseOverview"));
var _OverviewPublishedBy = _interopRequireDefault(require("./OverviewPublishedBy"));
var _OverviewPublishedOn = _interopRequireDefault(require("./OverviewPublishedOn"));
var _OverviewType = _interopRequireDefault(require("./OverviewType"));
var _OverviewOrganization = _interopRequireDefault(require("./OverviewOrganization"));
var _OverviewStatus = _interopRequireDefault(require("./OverviewStatus"));
var _OverviewVisibility = _interopRequireDefault(require("./OverviewVisibility"));
var _OverviewContactEmail = _interopRequireDefault(require("./OverviewContactEmail"));
var _OverviewContactName = _interopRequireDefault(require("./OverviewContactName"));
var _analytics = _interopRequireDefault(require("./analytics"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var CONTACT_INFORMATION_ENABLED = 'contact-information-enabled';
var Overview = function Overview(_ref) {
  var asset = _ref.asset,
    canEdit = _ref.canEdit,
    updateContactInfo = _ref.updateContactInfo;
  var trackEvent = (0, _exchangeReactHooks.useAnalyticsTracking)();
  var contactInfoEnabled = (0, _exchangeReactHooks.useFeatureFlag)(CONTACT_INFORMATION_ENABLED);
  (0, _react.useEffect)(function () {
    if (contactInfoEnabled) {
      if (canEdit === false && (asset.contactName || asset.contactEmail)) {
        trackEvent(_analytics.default.CONTACT_INFORMATION_LOADED);
      }
      if (canEdit) {
        trackEvent(_analytics.default.CONTACT_INFORMATION_EDIT_LOADED);
      }
    }
  }, [canEdit]); // canEdit begin as null and then has value

  var _React$useContext = _react.default.useContext(_exchangeReactHooks.AssetPortalContext),
    typeAttributes = _React$useContext.typeAttributes,
    versionsNavigation = _React$useContext.versionsNavigation;
  var config = (0, _exchangeReactHooks.useConfig)();
  return /*#__PURE__*/_react.default.createElement(_BaseOverview.default, {
    asset: asset
  }, /*#__PURE__*/_react.default.createElement(_OverviewType.default, {
    typeAttributes: typeAttributes
  }), /*#__PURE__*/_react.default.createElement(_OverviewOrganization.default, {
    asset: asset
  }), /*#__PURE__*/_react.default.createElement(_OverviewPublishedBy.default, {
    asset: asset
  }), /*#__PURE__*/_react.default.createElement(_OverviewPublishedOn.default, {
    asset: asset
  }), /*#__PURE__*/_react.default.createElement(_OverviewVisibility.default, {
    asset: asset,
    config: config,
    versionsNavigation: versionsNavigation
  }), contactInfoEnabled ? /*#__PURE__*/_react.default.createElement(_OverviewContactName.default, {
    asset: asset,
    canEdit: canEdit,
    updateContactInfo: updateContactInfo
  }) : null, contactInfoEnabled ? /*#__PURE__*/_react.default.createElement(_OverviewContactEmail.default, {
    asset: asset,
    canEdit: canEdit,
    updateContactInfo: updateContactInfo
  }) : null, /*#__PURE__*/_react.default.createElement(_OverviewStatus.default, {
    asset: asset
  }));
};
var _default = exports.default = Overview;
//# sourceMappingURL=Overview.js.map